import { useState } from 'react';
import appConstants from '../../../constants';

export default function useComparator() {

  const [comparedItemList, setComparedItemList] = useState([]);
  const [comparedItemCategory, setComparedItemCategory] = useState(null);

  function isItemBeingCompared(item, itemIdKey) {
    return comparedItemList.filter(comparedItem => comparedItem[itemIdKey]===item[itemIdKey]).length > 0;
  }

  function addItemToComparator(item, itemIdKey, itemCategory) {
    if(!comparedItemCategory) {
      setComparedItemCategory(itemCategory);
      if (!isItemBeingCompared(item, itemIdKey)) {
        setComparedItemList(previousValue => [...comparedItemList, item]);
      }
    }
    else {
      if(comparedItemCategory === itemCategory) {
        if (!isItemBeingCompared(item, itemIdKey)) {
          setComparedItemList(previousValue => [...comparedItemList, item]);
        }
      }
    }
  }

  function removeItemFromComparator(item, itemIdKey) {
    const newComparedItemList = [...comparedItemList.filter(comparedItem => comparedItem[itemIdKey]!==item[itemIdKey])];
    setComparedItemList( previousValue => newComparedItemList);
    if(newComparedItemList.length === 0) {
      setComparedItemCategory(null);
    }
  }

  function canAddToComparator() {
    return comparedItemList.length < appConstants.COMPARATOR_MAX_ITEM_COUNT_LIMIT;
  }

  function canActivateComparator() {
    const comparedItemListLength = comparedItemList.length;
    return (comparedItemListLength >= appConstants.COMPARATOR_MIN_ITEM_COUNT_LIMIT) &&
      (comparedItemListLength <= appConstants.COMPARATOR_MAX_ITEM_COUNT_LIMIT)
  }

  function getComparedItemComparatorActionLabel() {
    const computedComparedItemListLength = comparedItemList.length;
    if (computedComparedItemListLength < appConstants.COMPARATOR_MIN_ITEM_COUNT_LIMIT) {
      return computedComparedItemListLength + 1 === appConstants.COMPARATOR_MIN_ITEM_COUNT_LIMIT ?
               appConstants.LABEL_SELECT_AT_LEAST_ONE_MORE :
               appConstants.LABEL_COMPARE_SELECTED;
    }
    else {
      return appConstants.LABEL_COMPARE_SELECTED;
    }
  }

  function getNotComparedItemComparatorActionLabel() {
    const computedComparedItemListLength = comparedItemList.length;
    if (computedComparedItemListLength < appConstants.COMPARATOR_MAX_ITEM_COUNT_LIMIT) {
      return appConstants.LABEL_ADD_TO_COMPARE;
    }
    else {
      return appConstants.LABEL_ADD_TO_COMPARE;
    }
  }

  function clearComparator() {
    setComparedItemList( previousValue => []);
    setComparedItemCategory(null);
  }


  return {
    comparedItemList,
    comparedItemCategory,
    isItemBeingCompared,
    addItemToComparator,
    removeItemFromComparator,
    canAddToComparator,
    canActivateComparator,
    getComparedItemComparatorActionLabel,
    getNotComparedItemComparatorActionLabel,
    clearComparator
  }
}
